import React from 'react';

import styles from '../ideaUpdateStyles.scss';

import Link from 'buyside/components/presentation/Link/link';

import PaperStackIcon from 'buyside/svgs/paper_stack.svg';

import { ideaAttachmentUrl } from 'buyside/util/urlHelper';

const IdeaUpdateAttachments = ({ attachments }) => {
  if (!attachments.edges) return null;
  return (
    <>
      {attachments.edges.map(edge => {
        const attachment = edge.node;
        return (
          <div className={styles.attachment} key={attachment.id}>
            <PaperStackIcon className={styles.attachmentIcon} />
            <div>
              <div className={styles.label}>{attachment.attachmentType}</div>
              <div>
                <Link
                  to={ideaAttachmentUrl(attachment.id)}
                  target="_blank"
                  className={styles.fileLink}
                >
                  {attachment.filename}
                </Link>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default IdeaUpdateAttachments;
